export default function initSubnav() {
    const items = document.querySelectorAll('.header__wrap__menu__item');

    items.forEach(item => {
        const subnav = item.querySelector('.header__wrap__nav__link__subnav');
        if (!subnav) return;

        // Move to body so backdrop-filter escapes the header's stacking context
        document.body.appendChild(subnav);

        let hideTimer = null;

        const position = () => {
            const rect = item.getBoundingClientRect();
            subnav.style.top = `${rect.bottom + 8}px`;
            subnav.style.left = `${rect.left + rect.width / 2}px`;
        };

        const show = () => {
            clearTimeout(hideTimer);
            position();
            subnav.classList.add('is-open');
        };

        const hide = () => {
            hideTimer = setTimeout(() => {
                subnav.classList.remove('is-open');
            }, 100);
        };

        item.addEventListener('mouseenter', show);
        item.addEventListener('mouseleave', hide);
        subnav.addEventListener('mouseenter', () => clearTimeout(hideTimer));
        subnav.addEventListener('mouseleave', hide);
    });
}
